import axios from "axios";

// Use localhost when in development
// otherwise use environment variable
const BASE_URL = process.env.REACT_APP_REST_URI || "http://localhost:3000";

export const sendContactForm = async (data) => {
  return await axios.post(`${BASE_URL}/api/contact-us`, data, {
    headers: { "Content-Type": "application/json" },
  });
};

export const sendApplicationForm = async (formData) => {
  return await axios.post(`${BASE_URL}/api/application`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
